<div class="driver-map">
    <div class="driver-map__map">
      <app-common-map [mapHeight]="'100%'" [isCollapsed]="isCollapsed" [data]="driverLocations"
        [clusterRenderer]="clusterRenderer" [showDropdown]="false" [markerFactory]="markerFactory"
        [mapInfoWindowBuilder]="mapInfoWindowBuilder" [routeLink]="routeLink" [mapId]="'WEBTRACK_DRIVER_MAP'"
        [isLoading]="isLoading">
      </app-common-map>
    </div>
  </div>